import { useState } from 'react';

export default function FaqAccordion({ items = [], variant = 'light' }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!items || items.length === 0) return null;

  const isDark = variant === 'dark';

  if (isDark) {
    return (
      <div className="divide-y divide-zinc-800/80 border-y border-zinc-800/80 w-full">
        {items.map((item, idx) => {
          const isOpen = openIndex === idx;
          return (
            <div key={idx} className="transition-colors group">
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                aria-expanded={isOpen}
                className="w-full py-4 sm:py-5 text-left flex items-center justify-between gap-4 font-semibold text-zinc-100 hover:text-red-500 transition-colors focus:outline-none cursor-pointer"
              >
                <span className={`text-base sm:text-lg tracking-tight font-bold transition-colors ${
                  isOpen ? 'text-red-500' : 'text-white group-hover:text-red-400'
                }`}>
                  {item.question}
                </span>
                <span
                  className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ease-in-out text-sm ${
                    isOpen ? 'bg-red-600 text-white rotate-180 shadow-md' : 'bg-zinc-800 text-zinc-300 group-hover:bg-red-600 group-hover:text-white'
                  }`}
                  aria-hidden="true"
                >
                  <i className="fa-solid fa-chevron-down text-xs" />
                </span>
              </button>

              <div
                className={`grid transition-[grid-template-rows,opacity] duration-300 ease-in-out ${
                  isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0 pointer-events-none'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="pb-5 pt-2 pr-6 text-zinc-200 text-sm sm:text-base leading-relaxed pl-1">
                    <p>{item.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="divide-y divide-zinc-200 border-2 border-zinc-200 rounded-xl overflow-hidden bg-white shadow-sm">
      {items.map((item, idx) => {
        const isOpen = openIndex === idx;
        return (
          <div key={idx} className={`transition-colors group ${isOpen ? 'bg-zinc-50/50' : 'bg-white'}`}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? -1 : idx)}
              aria-expanded={isOpen}
              className="w-full py-4 sm:py-5 px-5 sm:px-6 text-left flex items-center justify-between gap-4 focus:outline-none cursor-pointer"
            >
              <span className={`text-base sm:text-lg tracking-tight font-bold transition-colors ${
                isOpen ? 'text-red-600 font-extrabold' : 'text-black group-hover:text-red-600'
              }`}>
                {item.question}
              </span>
              <span
                className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ease-in-out ${
                  isOpen
                    ? 'bg-red-600 text-white rotate-180 shadow-sm'
                    : 'bg-zinc-100 text-black group-hover:bg-red-600 group-hover:text-white'
                }`}
                aria-hidden="true"
              >
                <i className="fa-solid fa-chevron-down text-xs" />
              </span>
            </button>

            <div
              className={`grid transition-[grid-template-rows,opacity] duration-300 ease-in-out ${
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0 pointer-events-none'
              }`}
            >
              <div className="overflow-hidden">
                <div className="px-5 sm:px-6 pb-6 pt-3 text-black font-normal text-sm sm:text-base leading-relaxed border-t border-zinc-200 bg-white">
                  <p>{item.answer}</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
